import { useMemo } from 'react';

import { LettersOfMedicalNecessity } from '../myDocuments.types';
import { useDocumentsUrlsQuery } from '../queries';

const useGetPreviewForLMNs = (lmns: LettersOfMedicalNecessity[]) => {
  const ids = useMemo<string[]>(() => {
    return lmns.reduce((result: string[], item) => {
      if (item.documentId) {
        return [...result, item.documentId];
      }
      return result;
    }, []);
  }, [lmns]);

  const { isLoading, valuesMap } = useDocumentsUrlsQuery(ids);
  return {
    isLoading,
    valuesMap,
  };
};

export default useGetPreviewForLMNs;
